import styled from 'styled-components';

const Container = styled.div`
    margin: 0px auto;
    width: 100%;
    max-width: 1144px;
`;

export default Container;